// front-end/src/components/news-loader/news-feed-loader.js

import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {applyContentToElement, loadContentForElement} from '../content-editor-src';
import {isAuthenticated} from '../auth';
import {addDeleteButton} from '../block-system/block-manager/block-editor';
import {initSortable, makeBlockDraggable} from '../block-system/block-manager/block-sortable';

export class NewsFeedLoader {
    constructor() {
        console.log('[NewsFeedLoader] Инициализация начата');
        this.currentOffset = 0;
        this.itemsPerPage = 9;
        this.isLoading = false;
        this.hasMoreNews = true;
        this.container = null;
        this.loadMoreButton = null;
        this.isAuthenticated = isAuthenticated();
        this.initialized = false;
        this.loadedNewsCount = 0; // НОВОЕ: Счетчик загруженных новостей

        // Ждем полную загрузку DOM и блочной системы
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.init(), 800);
            });
        } else {
            setTimeout(() => this.init(), 800);
        }
    }

    init() {
        if (this.initialized) {
            console.log('[NewsFeedLoader] Уже инициализирован, пропускаем');
            return;
        }

        console.log('[NewsFeedLoader] init() - начало');

        // ВАЖНО: Инициализируем счетчики блоков
        try {
            const {initializeBlockCounters} = require('../block-system/block-manager/block-state');
            initializeBlockCounters();
            console.log('[NewsFeedLoader] Счетчики блоков инициализированы');
        } catch (error) {
            console.error('[NewsFeedLoader] Ошибка инициализации счетчиков:', error);
        }

        // Инициализируем только на странице news-feed
        if (window.location.pathname.match(/news-feed(\.html)?$/)) {
            console.log('[NewsFeedLoader] Страница news-feed - ищем контейнер');
            this.initElements();
        } else {
            console.log('[NewsFeedLoader] Не страница news-feed, пропускаем инициализацию');
        }
    }

    initElements() {
        // Находим контейнер по атрибуту data-section
        this.container = document.querySelector('[data-section="news-section-1"]');
        this.loadMoreButton = document.querySelector('.load-more-');

        console.log('[NewsFeedLoader] Контейнер найден:', !!this.container);
        console.log('[NewsFeedLoader] Кнопка загрузки найдена:', !!this.loadMoreButton);

        if (this.container) {
            this.initialized = true;
            console.log('[NewsFeedLoader] Настраиваем обработчики');

            if (this.container.dataset.ssr === 'true') {
                const ssrItems = this.container.querySelectorAll('[data-block-name]');
                this.currentOffset = ssrItems.length;
                this.loadedNewsCount = ssrItems.length;
                console.log(`[NewsFeedLoader] SSR контент обнаружен: ${ssrItems.length} новостей`);
            } else {
                this.clearExistingBlocks();
            }

            if (this.isAuthenticated) {
                initSortable(this.container);
            }

            this.setupLoadMoreButton();

            if (this.container.dataset.ssr !== 'true') {
                this.loadInitialNews();
            }
        } else {
            console.warn('[NewsFeedLoader] Контейнер news-section не найден!');
        }
    }

    clearExistingBlocks() {
        // Удаляем только блоки новостей, оставляя контролы секции
        const newsBlocks = this.container.querySelectorAll('[data-block-name^="news-block-"]');
        console.log(`[NewsFeedLoader] Удаляем ${newsBlocks.length} существующих блоков новостей`);
        newsBlocks.forEach(block => block.remove());
    }

    setupLoadMoreButton() {
        if (this.loadMoreButton) {
            const buttonElement = document.createElement('button');
            buttonElement.className = this.loadMoreButton.className;
            buttonElement.textContent = 'завантажити більше';

            this.loadMoreButton.parentNode.replaceChild(buttonElement, this.loadMoreButton);
            this.loadMoreButton = buttonElement;

            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.loadMoreNews();
            });

            console.log('[NewsFeedLoader] Кнопка "загрузить больше" настроена');
        }
    }

    async loadInitialNews() {
        console.log('[NewsFeedLoader] loadInitialNews() - начало');

        try {
            // Сбрасываем счетчики
            this.currentOffset = 0;
            this.loadedNewsCount = 0;
            this.hasMoreNews = true;

            // Очищаем только блоки новостей
            this.clearExistingBlocks();

            // Загружаем первые 9 новостей
            await this.loadNewsChunk(0);

        } catch (error) {
            console.error('[NewsFeedLoader] Ошибка при загрузке начальных новостей:', error);
            this.renderErrorState();
        }
    }

    async loadMoreNews() {
        if (this.isLoading || !this.hasMoreNews) {
            console.log('[NewsFeedLoader] Загрузка уже идет или нет больше новостей');
            return;
        }

        console.log('[NewsFeedLoader] loadMoreNews() - загружаем еще новости');

        try {
            await this.loadNewsChunk(this.currentOffset);
        } catch (error) {
            console.error('[NewsFeedLoader] Ошибка при загрузке дополнительных новостей:', error);
            this.showLoadMoreError();
        }
    }

    async loadNewsChunk(offset) {
        console.log(`[NewsFeedLoader] loadNewsChunk() - offset: ${offset}, limit: ${this.itemsPerPage}`);

        this.isLoading = true;
        this.updateLoadMoreButton('loading');

        try {
            // ВАЖНО: Добавляем exclude_cases=true для фильтрации на бэкенде
            let apiUrl = `${config.api.paths.newsOffset}?offset=${offset}&limit=${this.itemsPerPage}&exclude_cases=true`;
            console.log('[NewsFeedLoader] API URL:', apiUrl);

            // Send auth token so backend can distinguish valid admin from stale/no token.
            // Backend enforces status=published when token is absent or invalid.
            const response = await apiGet(apiUrl, {auth: this.isAuthenticated});
            console.log('[NewsFeedLoader] Ответ получен:', response);

            let newsItems = Array.isArray(response) ? response : [];

            // УБИРАЕМ фильтрацию кейсов на фронте - теперь это делает бэкенд
            console.log('[NewsFeedLoader] Количество новостей от API:', newsItems.length);

            if (newsItems.length > 0) {
                await this.renderNewsChunk(newsItems);

                // ВАЖНО: Обновляем offset на количество реально полученных новостей
                this.currentOffset += newsItems.length;
                this.loadedNewsCount += newsItems.length;

                console.log(`[NewsFeedLoader] Offset обновлен до: ${this.currentOffset}`);
                console.log(`[NewsFeedLoader] Всего загружено новостей: ${this.loadedNewsCount}`);

                // Проверяем, есть ли еще новости
                if (newsItems.length < this.itemsPerPage) {
                    console.log('[NewsFeedLoader] Получено меньше новостей чем запрашивали - это последний чанк');
                    this.hasMoreNews = false;
                    this.updateLoadMoreButton('no-more');
                } else {
                    console.log('[NewsFeedLoader] Есть еще новости, кнопка остается активной');
                    this.updateLoadMoreButton('ready');
                }
            } else {
                if (offset === 0) {
                    console.log('[NewsFeedLoader] Это был первый запрос - показываем пустое состояние');
                    this.renderEmptyState();
                }
                this.hasMoreNews = false;
                this.updateLoadMoreButton('no-more');
            }

        } catch (error) {
            console.error('[NewsFeedLoader] Ошибка при загрузке чанка новостей:', error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async renderNewsChunk(newsItems) {
        console.log(`[NewsFeedLoader] renderNewsChunk() - рендерим ${newsItems.length} новостей`);

        const newsElements = [];

        for (let i = 0; i < newsItems.length; i++) {
            const news = newsItems[i];
            console.log(`[NewsFeedLoader] Обрабатываем новость ${i + 1}:`, news.slug, 'Статус:', news.status);

            try {
                // ВАЖНО: Используем loadedNewsCount для правильного order
                const newsElement = this.createNewsElement(news, this.loadedNewsCount + i);

                // Добавляем элемент в контейнер
                this.container.appendChild(newsElement);
                newsElements.push(newsElement);

                console.log(`[NewsFeedLoader] Новость ${news.slug} добавлена в DOM`);
            } catch (error) {
                console.error(`[NewsFeedLoader] Ошибка при создании элемента новости ${news.slug}:`, error);
            }
        }

        // Загружаем контент для всех элементов
        for (let i = 0; i < newsElements.length; i++) {
            const newsElement = newsElements[i];
            const news = newsItems[i];

            try {
                await this.loadNewsContent(newsElement, news);
                console.log(`[NewsFeedLoader] Контент загружен для ${news.slug}`);
            } catch (error) {
                console.error(`[NewsFeedLoader] Ошибка при загрузке контента для ${news.slug}:`, error);
            }
        }

        // Добавляем контролы блочной системы после загрузки контента
        if (this.isAuthenticated) {
            console.log('[NewsFeedLoader] Добавляем контролы для аутентифицированного пользователя');
            for (let i = 0; i < newsElements.length; i++) {
                const newsElement = newsElements[i];
                const news = newsItems[i];
                this.addBlockControls(newsElement, news);
            }
        }
    }

    createNewsElement(news, globalIndex) {
        console.log('[NewsFeedLoader] createNewsElement() для:', news.slug);
        console.log('[NewsFeedLoader] Полные данные новости:', JSON.stringify(news, null, 2));

        const newsItem = document.createElement('div');
        newsItem.className = 'news-feed-item';
        newsItem.setAttribute('data-block-name', `${news.slug}`);
        newsItem.setAttribute('data-block-id', news.block_id || `${news.id}`);
        newsItem.setAttribute('data-news-id', news.id);
        newsItem.setAttribute('data-news-status', news.status);
        newsItem.setAttribute('data-news-slug', news.slug);
        newsItem.setAttribute('data-order', String(globalIndex)); // Используем глобальный индекс
        newsItem.style.position = 'relative';
        newsItem.style.cursor = 'pointer';

        // ИСПРАВЛЯЕМ: Проверяем статус для активации ссылки
        const isActiveLink = true;
        const newsHref = isActiveLink ? (news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`) : '#';

        console.log(`[NewsFeedLoader] Новость ${news.slug}: статус="${news.status}", активная ссылка=${isActiveLink}, href="${newsHref}"`);
        const isAuth = isAuthenticated();

        const statusIndicatorHTML = isAuth
            ? `
    <div class="news-status-indicator status-${news.status}">
        <span class="status-text">${news.status.toUpperCase()}</span>
    </div>
  `
            : '';

        newsItem.addEventListener('click', (e) => {
            if (!e.target.closest('a') && !e.target.closest('button') && !e.target.closest('.edit-btn') && !e.target.closest('.block-delete-button')) {
                if (isActiveLink) window.location.href = newsHref;
            }
        });

        newsItem.innerHTML = `
    <div class="news-feed-content">
        <div class="news-feed-upper">
            <img class="news-feed-image" src="" alt="News Image" 
                 data-content="${news.slug}-image" data-type="image" data-global="true">
            <a href="${newsHref}" ${isActiveLink ? `data-page="${news.slug}"` : ''} 
               class="news-link ${isActiveLink ? 'active' : 'inactive'}"
               ${!isActiveLink ? 'onclick="event.preventDefault(); return false;"' : ''}
               style="${!isActiveLink ? 'pointer-events: none; opacity: 0.5;' : ''}">
                <img src="images/news-button.svg" alt="news-button" class="news-button default">
                <img src="images/news-button-hover.svg" alt="news-button-hover" class="news-button hover">
            </a>
        </div>
        <div class="news-feed-info">
            <h3 class="news-feed-title" data-content="${news.slug}-title" data-global="true"></h3>
            <p class="news-feed-description" data-content="${news.slug}-description" 
               data-type="textarea" data-global="true"></p>
        </div>
    </div>
    ${statusIndicatorHTML}
`;

        // Добавляем стили для неактивных ссылок
        if (!isActiveLink) {
            const linkElement = newsItem.querySelector('.news-link');
            if (linkElement) {
                linkElement.style.pointerEvents = 'none';
                linkElement.style.opacity = '0.5';
                linkElement.style.cursor = 'not-allowed';

                // Также делаем неактивными изображения внутри
                const newsButtons = linkElement.querySelectorAll('.news-button');
                newsButtons.forEach(btn => {
                    btn.style.opacity = '0.5';
                });
            }
        }

        return newsItem;
    }

    addBlockControls(newsElement, news) {
        console.log(`[NewsFeedLoader] Добавляем контролы для блока ${news.slug}`);

        // Проверяем, есть ли уже кнопка удаления
        if (!newsElement.querySelector('.block-delete-button')) {
            const blockId = newsElement.getAttribute('data-block-id');
            if (blockId) {
                addDeleteButton(newsElement, blockId);
                console.log(`[NewsFeedLoader] Кнопка удаления добавлена для ${news.slug}`);
            }
        }

        // Делаем блок перетаскиваемым
        if (!newsElement.hasAttribute('draggable')) {
            newsElement.setAttribute('draggable', 'true');
            makeBlockDraggable(newsElement);
            console.log(`[NewsFeedLoader] Блок ${news.slug} сделан перетаскиваемым`);
        }

        // Добавляем контролы статуса новости
        if (window.newsManager && news.id) {
            window.newsManager.addStatusControlsToBlock(newsElement, news.id);
            console.log(`[NewsFeedLoader] Контролы статуса добавлены для ${news.slug}`);
        }
    }

    async loadNewsContent(newsElement, news) {
        console.log('[NewsFeedLoader] loadNewsContent() для:', news.slug);

        const contentElements = newsElement.querySelectorAll('[data-content]');
        console.log('[NewsFeedLoader] Найдено элементов с data-content:', contentElements.length);

        for (let i = 0; i < contentElements.length; i++) {
            const element = contentElements[i];
            const tagId = element.getAttribute('data-content');
            const isGlobal = element.getAttribute('data-global') === 'true';

            try {
                const data = await loadContentForElement(element, '', tagId, isGlobal);
                if (data) {
                    applyContentToElement(element, data);
                } else {
                    this.setDefaultContent(element, news, tagId);
                }
            } catch (error) {
                console.warn(`[NewsFeedLoader] Ошибка загрузки контента для ${tagId}:`, error);
                this.setDefaultContent(element, news, tagId);
            }
        }
    }

    setDefaultContent(element, news, tagId) {
        if (tagId.endsWith('-title')) {
            element.textContent = news.title || 'Без названия';
        } else if (tagId.endsWith('-description')) {
            element.textContent = news.preview_text || '';
        }
    }

    updateLoadMoreButton(state) {
        if (!this.loadMoreButton) return;

        switch (state) {
            case 'loading':
                this.loadMoreButton.textContent = 'завантажується...';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                break;

            case 'ready':
                this.loadMoreButton.textContent = 'завантажити більше';
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.style.opacity = '1';
                this.loadMoreButton.style.display = 'block';
                break;

            case 'no-more':
                this.loadMoreButton.textContent = 'усі новини завантажено';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                setTimeout(() => {
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = 'none';
                    }
                }, 3000);
                break;
        }
    }

    showLoadMoreError() {
        if (this.loadMoreButton) {
            this.loadMoreButton.textContent = 'помилка завантаження';
            this.loadMoreButton.disabled = false;
            this.loadMoreButton.style.opacity = '1';

            setTimeout(() => {
                this.updateLoadMoreButton('ready');
            }, 3000);
        }
    }

    renderEmptyState() {
        console.log('[NewsFeedLoader] renderEmptyState()');
        this.container.innerHTML = `
            <div class="news-empty-state" style="text-align: center; padding: 40px;">
                <h3>Новини скоро з'являться</h3>
                <p>Наразі немає опублікованих новин</p>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    renderErrorState() {
        console.log('[NewsFeedLoader] renderErrorState()');
        this.container.innerHTML = `
            <div class="news-error-state" style="text-align: center; padding: 40px;">
                <h3>Не вдалося завантажити новини</h3>
                <p>Спробуйте оновити сторінку</p>
                <button onclick="location.reload()" style="
                    padding: 10px 20px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-top: 10px;
                ">Оновити сторінку</button>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    // Публичный метод для перезагрузки новостей
    async reload() {
        console.log('[NewsFeedLoader] Перезагрузка новостей');
        this.currentOffset = 0;
        this.loadedNewsCount = 0;
        this.hasMoreNews = true;
        await this.loadInitialNews();
    }
}

// Создаем и экспортируем экземпляр
console.log('[NewsFeedLoader] Создаем экземпляр');
export const newsFeedLoader = new NewsFeedLoader();